import { AppPhase, DealingSubPhase } from '../models/communication/app-enums.model';
import { TableUpdate } from '../models/communication/app-state.model';

export abstract class GameFlowBase<Game> {
    protected readonly game!: Game;

    constructor(game: Game) {
        this.game = game;
    }

    abstract update(tableUpdate?: TableUpdate, appPhase?: AppPhase, dealingSubPhase?: DealingSubPhase): void;
}
